import select2 from 'select2';

select2();

$(document).ready(() => {
  $('select:not([data-skip-select2])').each(function () {
    $(this).select2({
      minimumResultsForSearch: this.dataset.updateSearchResult || 0
    });
  });
});
